export const EMPLOYEE_PORTAL_EDIT_PROFILE = "edit_employee_portal_profile";
export const EMPLOYEE_PORTAL_EDIT_PROFILE_SUCCESS =
  "edit_employee_portal_profile_success";
export const EMPLOYEE_PORTAL_EDIT_PROFILE_FAILURE =
  "edit_employee_portal_profile_failure";
export const RESET_EMPLOYEE_PORTAL_EDIT_PROFILE =
  "RESET_EMPLOYEE_PORTAL_EDIT_PROFILE";
